import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import ScaleContext from "../../context/scale/context";
import ScaleContextProvider from "../../context/scale/provider";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import ScaleTable from "../../components/scale/scale-table";
import ScaleFilter from "../../components/scale/scale-filter";
import SearchFilterCard from "../../components/general/filter-card";
import Can from "../../utils/rbac/can";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { Permissions } from "../../utils/Permissions/Permissions";

interface IProps {
  children?: React.ReactNode;
}

const ScaleComponent: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(ScaleContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);

  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("scales")}
        subTitle={t("scales_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Can key={2} perform={Permissions.CAN_CREATE_SCALE}>
            <Divider key={1} type="vertical" />
            <Button
              type="primary"
              onClick={() => {
                navigate(`/scales/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_scale")}
            </Button>
          </Can>,
        ]}
      />
      <SearchFilterCard
        formId="scale-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
          const form = document.getElementById("scale-filter");
          if (form) {
            form.dispatchEvent(
              new Event("reset", { cancelable: true, bubbles: true })
            );
          }
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        <ScaleFilter />
      </SearchFilterCard>

      <ScaleTable />
    </div>
  );
};

const ScalePage = () => {
  return (
    <ScaleContextProvider>
      <ScaleComponent />
    </ScaleContextProvider>
  );
};

export default ScalePage;
